import React, { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '9726344477';
  const [message, setMessage] = useState('');

  const predefinedMessages = [
    'I want to invest in Mutual Funds',
    'I need Health Insurance',
    'I want to calculate my SIP returns',
    'I need Retirement Planning advice',
    'I want to know about Home Loans',
    'Schedule a consultation with advisor',
  ];

  const sendMessage = (text) => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, '_blank');
    setIsOpen(false);
  };

  return (
    <div className="fixed bottom-20 right-5 z-50">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            className="absolute bottom-16 right-0 mb-2 w-80 bg-white rounded-2xl shadow-2xl overflow-hidden"
          >
            <div className="bg-green-500 text-white p-4 flex justify-between items-center">
              <div className="flex items-center space-x-2">
                <FaWhatsapp size={24} />
                <div>
                  <h4 className="font-bold">Chat with us on WhatsApp</h4>
                  <p className="text-xs opacity-90">We usually reply within 5 minutes</p>
                </div>
              </div>
              <button onClick={() => setIsOpen(false)} className="hover:bg-green-600 rounded-full p-1">
                <FaTimes />
              </button>
            </div>
            <div className="p-4">
              <p className="text-gray-600 text-sm mb-3">Select a quick message or type your own:</p>
              <div className="space-y-2 mb-3">
                {predefinedMessages.map((msg, idx) => (
                  <button
                    key={idx}
                    onClick={() => sendMessage(msg)}
                    className="w-full text-left px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                  >
                    {msg}
                  </button>
                ))}
              </div>
              <div className="flex space-x-2">
                <input
                  type="text"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Type your message..."
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-green-500"
                />
                <button
                  onClick={() => message && sendMessage(message)}
                  className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 transition-colors"
                >
                  Send
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => setIsOpen(!isOpen)}
        className="bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 animate-bounce"
      >
        <FaWhatsapp size={30} />
      </motion.button>
    </div>
  );
};

export default WhatsAppButton;